import { gql, useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { Pack, WithFeatures } from 'apollo/types';
import getApiLanguage from 'i18n/apiLanguage';

const LIST_PACKS = gql`
  query listPacks($language: Language) {
    listPacks(language: $language) {
      id
      name
      adultValue
      otherValue
      description
      status
      visibility
      activities {
        id
        name
      }
      entranceTicketTypes {
        id
        name
      }
      packImages {
        image
      }
      features {
        slug
        name
        availability
        position
        note
      }
    }
  }
`;

const useListPacksQuery = () => {
  const { i18n } = useTranslation();

  return useQuery<{ listPacks: WithFeatures<Pack>[] }>(LIST_PACKS, {
    variables: { language: getApiLanguage(i18n.language) },
  });
};
export default useListPacksQuery;
